import { CriteriaSurveyPanelistsReadModel } from "@Evaluation/CriteriaSurveys/Domain/readmodels";

export class CriteriaSurveyAccessLinksViewModel
{
    opened: boolean = false;

    surveyId: number | null = null;
    data: CriteriaSurveyPanelistsReadModel | null = null;

    show(surveyId: number)
    {
        this.data = null;
        this.surveyId = surveyId;

        this.opened = true;
    }

    setData(data: CriteriaSurveyPanelistsReadModel)
    {
        this.data = data;
    }

    close()
    {
        this.opened = false;

        this.data = null;
        this.surveyId = null;
    }
}